import React, { useRef } from 'react';
import Button from '@atlaskit/button/new';
export var chooseFileButtonTestId = 'choose-file-button';
export var fileUploadInputTestId = 'file-upload';
var FileChooser = function FileChooser(props) {
  var accept = props.accept,
    ariaDescribedBy = props.ariaDescribedBy,
    isDisabled = props.isDisabled,
    label = props.label,
    onChange = props.onChange,
    onClick = props.onClick;
  var filePickerRef = useRef(null);
  var fileButtonRef = useRef(null);
  var handleOnChooseFile = function handleOnChooseFile() {
    var _fileButtonRef$curren;
    if (!filePickerRef.current) {
      return;
    }
    if (onClick) {
      onClick();
    }
    filePickerRef.current.click();
    (_fileButtonRef$curren = fileButtonRef.current) === null || _fileButtonRef$curren === void 0 || _fileButtonRef$curren.focus();
  };
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleOnChooseFile,
    isDisabled: isDisabled,
    "aria-describedby": ariaDescribedBy,
    testId: chooseFileButtonTestId,
    ref: fileButtonRef
  }, label), /*#__PURE__*/React.createElement("input", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: "emojiUploadFileInput",
    ref: filePickerRef,
    onChange: onChange,
    type: "file",
    accept: accept
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: {
      display: 'none'
    },
    "data-testid": fileUploadInputTestId
  }));
};
export default FileChooser;